module.exports = __webpack_public_path__ + "static/media/person_black.bcbb6859.svg";